import { Pipe, PipeTransform } from '@angular/core';
import { IFile } from '@shared/interfaces/file/file';

@Pipe({
  name: 'catalogFilter'
})
export class CatalogFilterPipe implements PipeTransform {

  transform(items: IFile[], isCatalog: boolean): IFile[] {
    return items.filter((item: IFile) =>  item.isCatalog === isCatalog);
  }

}
